module.exports = __webpack_public_path__ + "img/4-3.e79a5d10.svg";